import { PublicClientApplication } from '@azure/msal-browser';
import { getUipConfig } from '../config/actions';
/** Singleton */
var msal;
export var getMsalClient = function () {
    return msal || (msal = new PublicClientApplication(getUipConfig()));
};
